import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { WhiteSpace, WingBlank } from "foui";
import AppLayout from "components/AppLayout/index";
import AppNavBar from "components/AppNavBar/index";
import styles from "./index.m.scss";

@observer
class Page404 extends React.Component {
  render() {
    return (
      <AppLayout navBar={<AppNavBar>404</AppNavBar>}>
        <h1>404</h1>
        <p>{window.location.href}</p>
      </AppLayout>
    );
  }
}

Page404.propTypes = {
  // props1: PropTypes.node.isRequired
};
Page404.defaultProps = {
  // props1: undefined
};

export default Page404;



// WEBPACK FOOTER //
// ./src/pages/Page404/index.js